// Static mapping of Question IDs to their teaching locations in the curriculum.
// Generated automatically by generate_mappings.js.

export interface QuestionLocation {
    lessonId: string;
    lessonTitle: string;
    moduleId: string;
    moduleTitle: string;
}

export const questionMapping: Record<string, QuestionLocation> = {
    "M1-001": {
        "lessonId": "lesson-1-1",
        "lessonTitle": "The Highway Transportation System (HTS)",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M1-006": {
        "lessonId": "lesson-1-1",
        "lessonTitle": "The Highway Transportation System (HTS)",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M1-021": {
        "lessonId": "lesson-1-1",
        "lessonTitle": "The Highway Transportation System (HTS)",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M1-004": {
        "lessonId": "lesson-1-1",
        "lessonTitle": "The Highway Transportation System (HTS)",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M1-013": {
        "lessonId": "lesson-1-1",
        "lessonTitle": "The Highway Transportation System (HTS)",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M1-025": {
        "lessonId": "lesson-1-1",
        "lessonTitle": "The Highway Transportation System (HTS)",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M1-012": {
        "lessonId": "lesson-1-1",
        "lessonTitle": "The Highway Transportation System (HTS)",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M1-010": {
        "lessonId": "lesson-1-1",
        "lessonTitle": "The Highway Transportation System (HTS)",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M1-002": {
        "lessonId": "lesson-1-1",
        "lessonTitle": "The Highway Transportation System (HTS)",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M1-007": {
        "lessonId": "lesson-1-1",
        "lessonTitle": "The Highway Transportation System (HTS)",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M1-022": {
        "lessonId": "lesson-1-1",
        "lessonTitle": "The Highway Transportation System (HTS)",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M1-023": {
        "lessonId": "lesson-1-1",
        "lessonTitle": "The Highway Transportation System (HTS)",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M1-015": {
        "lessonId": "lesson-1-1",
        "lessonTitle": "The Highway Transportation System (HTS)",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M1-017": {
        "lessonId": "lesson-1-1",
        "lessonTitle": "The Highway Transportation System (HTS)",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M1-020": {
        "lessonId": "lesson-1-1",
        "lessonTitle": "The Highway Transportation System (HTS)",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M1-011": {
        "lessonId": "lesson-1-2",
        "lessonTitle": "Getting Your Driver",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M1-003": {
        "lessonId": "lesson-1-2",
        "lessonTitle": "Getting Your Driver",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M1-016": {
        "lessonId": "lesson-1-2",
        "lessonTitle": "Getting Your Driver",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M1-005": {
        "lessonId": "lesson-1-2",
        "lessonTitle": "Getting Your Driver",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M1-024": {
        "lessonId": "lesson-1-3",
        "lessonTitle": "Driver Education Value",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M1-014": {
        "lessonId": "lesson-1-3",
        "lessonTitle": "Driver Education Value",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M1-009": {
        "lessonId": "lesson-1-3",
        "lessonTitle": "Driver Education Value",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M1-008": {
        "lessonId": "lesson-1-3",
        "lessonTitle": "Driver Education Value",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M1-018": {
        "lessonId": "lesson-1-3",
        "lessonTitle": "Driver Education Value",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M1-019": {
        "lessonId": "lesson-1-4",
        "lessonTitle": "Anatomical Gifts",
        "moduleId": "module-1",
        "moduleTitle": "Module 1: The System & You"
    },
    "M2-011": {
        "lessonId": "lesson-2-1",
        "lessonTitle": "Safety Systems",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M2-012": {
        "lessonId": "lesson-2-1",
        "lessonTitle": "Safety Systems",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M2-017": {
        "lessonId": "lesson-2-1",
        "lessonTitle": "Safety Systems",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M2-025": {
        "lessonId": "lesson-2-2",
        "lessonTitle": "Control Systems",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M2-021": {
        "lessonId": "lesson-2-2",
        "lessonTitle": "Control Systems",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M2-001": {
        "lessonId": "lesson-2-2",
        "lessonTitle": "Control Systems",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M2-007": {
        "lessonId": "lesson-2-2",
        "lessonTitle": "Control Systems",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M2-014": {
        "lessonId": "lesson-2-2",
        "lessonTitle": "Control Systems",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M2-019": {
        "lessonId": "lesson-2-2",
        "lessonTitle": "Control Systems",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M2-023": {
        "lessonId": "lesson-2-3",
        "lessonTitle": "Driver Visibility Systems",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M2-002": {
        "lessonId": "lesson-2-3",
        "lessonTitle": "Driver Visibility Systems",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M2-015": {
        "lessonId": "lesson-2-3",
        "lessonTitle": "Driver Visibility Systems",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M2-016": {
        "lessonId": "lesson-2-3",
        "lessonTitle": "Driver Visibility Systems",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M2-020": {
        "lessonId": "lesson-2-3",
        "lessonTitle": "Driver Visibility Systems",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M2-003": {
        "lessonId": "lesson-2-3",
        "lessonTitle": "Driver Visibility Systems",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M2-018": {
        "lessonId": "lesson-2-3",
        "lessonTitle": "Driver Visibility Systems",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M2-005": {
        "lessonId": "lesson-2-4",
        "lessonTitle": "Communication Systems",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M2-009": {
        "lessonId": "lesson-2-4",
        "lessonTitle": "Communication Systems",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M2-013": {
        "lessonId": "lesson-2-4",
        "lessonTitle": "Communication Systems",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M2-004": {
        "lessonId": "lesson-2-4",
        "lessonTitle": "Communication Systems",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M2-008": {
        "lessonId": "lesson-2-5",
        "lessonTitle": "Anti-Theft System",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M2-010": {
        "lessonId": "lesson-2-6",
        "lessonTitle": "Pre-Drive Checks",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M2-022": {
        "lessonId": "lesson-2-7",
        "lessonTitle": "Fitting the Vehicle to You",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M2-024": {
        "lessonId": "lesson-2-7",
        "lessonTitle": "Fitting the Vehicle to You",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M2-006": {
        "lessonId": "lesson-2-7",
        "lessonTitle": "Fitting the Vehicle to You",
        "moduleId": "module-2",
        "moduleTitle": "Module 2: Vehicle Familiarization"
    },
    "M3-001": {
        "lessonId": "lesson-3-1",
        "lessonTitle": "Demonstrate the Ready to Drive Position",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M3-002": {
        "lessonId": "lesson-3-1",
        "lessonTitle": "Demonstrate the Ready to Drive Position",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M3-003": {
        "lessonId": "lesson-3-1",
        "lessonTitle": "Demonstrate the Ready to Drive Position",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M3-014": {
        "lessonId": "lesson-3-1",
        "lessonTitle": "Demonstrate the Ready to Drive Position",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M3-012": {
        "lessonId": "lesson-3-1",
        "lessonTitle": "Demonstrate the Ready to Drive Position",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M3-020": {
        "lessonId": "lesson-3-1",
        "lessonTitle": "Demonstrate the Ready to Drive Position",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M3-025": {
        "lessonId": "lesson-3-10",
        "lessonTitle": "Reversing Direction",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M3-022": {
        "lessonId": "lesson-3-11",
        "lessonTitle": "Parking",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M3-006": {
        "lessonId": "lesson-3-2",
        "lessonTitle": "Starting the Vehicle",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M3-011": {
        "lessonId": "lesson-3-2",
        "lessonTitle": "Starting the Vehicle",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M3-007": {
        "lessonId": "lesson-3-2",
        "lessonTitle": "Starting the Vehicle",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M3-004": {
        "lessonId": "lesson-3-2",
        "lessonTitle": "Starting the Vehicle",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M3-005": {
        "lessonId": "lesson-3-2",
        "lessonTitle": "Starting the Vehicle",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M3-018": {
        "lessonId": "lesson-3-2",
        "lessonTitle": "Starting the Vehicle",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M3-016": {
        "lessonId": "lesson-3-2",
        "lessonTitle": "Starting the Vehicle",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M3-019": {
        "lessonId": "lesson-3-2",
        "lessonTitle": "Starting the Vehicle",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M3-015": {
        "lessonId": "lesson-3-3",
        "lessonTitle": "Putting the Vehicle in Motion",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M3-013": {
        "lessonId": "lesson-3-4",
        "lessonTitle": "Steering",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M3-008": {
        "lessonId": "lesson-3-4",
        "lessonTitle": "Steering",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M3-023": {
        "lessonId": "lesson-3-4",
        "lessonTitle": "Steering",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M3-017": {
        "lessonId": "lesson-3-5",
        "lessonTitle": "Slowing and Stopping the Vehicle",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M3-010": {
        "lessonId": "lesson-3-5",
        "lessonTitle": "Slowing and Stopping the Vehicle",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M3-009": {
        "lessonId": "lesson-3-6",
        "lessonTitle": "Changing Lanes",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M3-021": {
        "lessonId": "lesson-3-7",
        "lessonTitle": "Making Left & Right Turns",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M3-024": {
        "lessonId": "lesson-3-9",
        "lessonTitle": "Backing",
        "moduleId": "module-3",
        "moduleTitle": "Module 3: Basic Control Tasks"
    },
    "M4-001": {
        "lessonId": "lesson-4-1",
        "lessonTitle": "Pavement/Roadway Markings",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M4-003": {
        "lessonId": "lesson-4-1",
        "lessonTitle": "Pavement/Roadway Markings",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M4-002": {
        "lessonId": "lesson-4-1",
        "lessonTitle": "Pavement/Roadway Markings",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M4-004": {
        "lessonId": "lesson-4-1",
        "lessonTitle": "Pavement/Roadway Markings",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M4-020": {
        "lessonId": "lesson-4-1",
        "lessonTitle": "Pavement/Roadway Markings",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M4-023": {
        "lessonId": "lesson-4-1",
        "lessonTitle": "Pavement/Roadway Markings",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M4-017": {
        "lessonId": "lesson-4-1",
        "lessonTitle": "Pavement/Roadway Markings",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M4-016": {
        "lessonId": "lesson-4-1",
        "lessonTitle": "Pavement/Roadway Markings",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M4-005": {
        "lessonId": "lesson-4-1",
        "lessonTitle": "Pavement/Roadway Markings",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M4-025": {
        "lessonId": "lesson-4-1",
        "lessonTitle": "Pavement/Roadway Markings",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M4-019": {
        "lessonId": "lesson-4-2",
        "lessonTitle": "Traffic Signs",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M4-010": {
        "lessonId": "lesson-4-2",
        "lessonTitle": "Traffic Signs",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M4-009": {
        "lessonId": "lesson-4-2",
        "lessonTitle": "Traffic Signs",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M4-007": {
        "lessonId": "lesson-4-2",
        "lessonTitle": "Traffic Signs",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M4-011": {
        "lessonId": "lesson-4-2",
        "lessonTitle": "Traffic Signs",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M4-006": {
        "lessonId": "lesson-4-2",
        "lessonTitle": "Traffic Signs",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M4-008": {
        "lessonId": "lesson-4-2",
        "lessonTitle": "Traffic Signs",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M4-012": {
        "lessonId": "lesson-4-3",
        "lessonTitle": "Traffic Signals",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M4-018": {
        "lessonId": "lesson-4-3",
        "lessonTitle": "Traffic Signals",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M4-015": {
        "lessonId": "lesson-4-3",
        "lessonTitle": "Traffic Signals",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M4-013": {
        "lessonId": "lesson-4-3",
        "lessonTitle": "Traffic Signals",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M4-014": {
        "lessonId": "lesson-4-4",
        "lessonTitle": "Additional Signal Messaging",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M4-024": {
        "lessonId": "lesson-4-7",
        "lessonTitle": "Right-of-Way",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M4-021": {
        "lessonId": "lesson-4-7",
        "lessonTitle": "Right-of-Way",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M4-022": {
        "lessonId": "lesson-4-7",
        "lessonTitle": "Right-of-Way",
        "moduleId": "module-4",
        "moduleTitle": "Module 4: Traffic Control Devices & Laws"
    },
    "M5-003": {
        "lessonId": "lesson-5-1",
        "lessonTitle": "Space Management Systems",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M5-020": {
        "lessonId": "lesson-5-1",
        "lessonTitle": "Space Management Systems",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M5-019": {
        "lessonId": "lesson-5-1",
        "lessonTitle": "Space Management Systems",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M5-013": {
        "lessonId": "lesson-5-1",
        "lessonTitle": "Space Management Systems",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M5-009": {
        "lessonId": "lesson-5-1",
        "lessonTitle": "Space Management Systems",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M5-008": {
        "lessonId": "lesson-5-1",
        "lessonTitle": "Space Management Systems",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M5-007": {
        "lessonId": "lesson-5-1",
        "lessonTitle": "Space Management Systems",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M5-006": {
        "lessonId": "lesson-5-1",
        "lessonTitle": "Space Management Systems",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M5-001": {
        "lessonId": "lesson-5-1",
        "lessonTitle": "Space Management Systems",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M5-005": {
        "lessonId": "lesson-5-1",
        "lessonTitle": "Space Management Systems",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M5-016": {
        "lessonId": "lesson-5-1",
        "lessonTitle": "Space Management Systems",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M5-025": {
        "lessonId": "lesson-5-1",
        "lessonTitle": "Space Management Systems",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M5-017": {
        "lessonId": "lesson-5-2",
        "lessonTitle": "Space Management Content Specifics",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M5-015": {
        "lessonId": "lesson-5-2",
        "lessonTitle": "Space Management Content Specifics",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M5-004": {
        "lessonId": "lesson-5-2",
        "lessonTitle": "Space Management Content Specifics",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M5-002": {
        "lessonId": "lesson-5-2",
        "lessonTitle": "Space Management Content Specifics",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M5-014": {
        "lessonId": "lesson-5-2",
        "lessonTitle": "Space Management Content Specifics",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M5-010": {
        "lessonId": "lesson-5-2",
        "lessonTitle": "Space Management Content Specifics",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M5-011": {
        "lessonId": "lesson-5-2",
        "lessonTitle": "Space Management Content Specifics",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M5-021": {
        "lessonId": "lesson-5-3",
        "lessonTitle": "Using Time to Manage Space",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M5-012": {
        "lessonId": "lesson-5-3",
        "lessonTitle": "Using Time to Manage Space",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M5-018": {
        "lessonId": "lesson-5-4",
        "lessonTitle": "Sharing the Road",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M5-022": {
        "lessonId": "lesson-5-5",
        "lessonTitle": "Driving Environments",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M5-024": {
        "lessonId": "lesson-5-5",
        "lessonTitle": "Driving Environments",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M5-023": {
        "lessonId": "lesson-5-5",
        "lessonTitle": "Driving Environments",
        "moduleId": "module-5",
        "moduleTitle": "Module 5: Perception & Driving Strategies for Different Environments"
    },
    "M6-001": {
        "lessonId": "lesson-6-1",
        "lessonTitle": "Gravity",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M6-002": {
        "lessonId": "lesson-6-1",
        "lessonTitle": "Gravity",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M6-008": {
        "lessonId": "lesson-6-1",
        "lessonTitle": "Gravity",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M6-003": {
        "lessonId": "lesson-6-1",
        "lessonTitle": "Gravity",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M6-004": {
        "lessonId": "lesson-6-1",
        "lessonTitle": "Gravity",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M6-019": {
        "lessonId": "lesson-6-1",
        "lessonTitle": "Gravity",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M6-023": {
        "lessonId": "lesson-6-1",
        "lessonTitle": "Gravity",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M6-021": {
        "lessonId": "lesson-6-1",
        "lessonTitle": "Gravity",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M6-014": {
        "lessonId": "lesson-6-2",
        "lessonTitle": "Kinetic Energy",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M6-015": {
        "lessonId": "lesson-6-2",
        "lessonTitle": "Kinetic Energy",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M6-020": {
        "lessonId": "lesson-6-2",
        "lessonTitle": "Kinetic Energy",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M6-016": {
        "lessonId": "lesson-6-2",
        "lessonTitle": "Kinetic Energy",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M6-017": {
        "lessonId": "lesson-6-2",
        "lessonTitle": "Kinetic Energy",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M6-018": {
        "lessonId": "lesson-6-2",
        "lessonTitle": "Kinetic Energy",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M6-009": {
        "lessonId": "lesson-6-3",
        "lessonTitle": "Friction, Traction, & Centrifugal Force",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M6-010": {
        "lessonId": "lesson-6-3",
        "lessonTitle": "Friction, Traction, & Centrifugal Force",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M6-011": {
        "lessonId": "lesson-6-3",
        "lessonTitle": "Friction, Traction, & Centrifugal Force",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M6-012": {
        "lessonId": "lesson-6-3",
        "lessonTitle": "Friction, Traction, & Centrifugal Force",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M6-013": {
        "lessonId": "lesson-6-3",
        "lessonTitle": "Friction, Traction, & Centrifugal Force",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M6-022": {
        "lessonId": "lesson-6-3",
        "lessonTitle": "Friction, Traction, & Centrifugal Force",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M6-024": {
        "lessonId": "lesson-6-3",
        "lessonTitle": "Friction, Traction, & Centrifugal Force",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M6-005": {
        "lessonId": "lesson-6-4",
        "lessonTitle": "Center of Gravity & Stability",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M6-006": {
        "lessonId": "lesson-6-4",
        "lessonTitle": "Center of Gravity & Stability",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M6-007": {
        "lessonId": "lesson-6-5",
        "lessonTitle": "Force of Impact & Occupant Protection",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M6-025": {
        "lessonId": "lesson-6-5",
        "lessonTitle": "Force of Impact & Occupant Protection",
        "moduleId": "module-6",
        "moduleTitle": "Module 6: Natural Laws Affecting Vehicle & Operator Performance"
    },
    "M7-022": {
        "lessonId": "lesson-7-1",
        "lessonTitle": "Vehicle Emergencies (Equipment Failure)",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M7-001": {
        "lessonId": "lesson-7-1",
        "lessonTitle": "Vehicle Emergencies (Equipment Failure)",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M7-005": {
        "lessonId": "lesson-7-1",
        "lessonTitle": "Vehicle Emergencies (Equipment Failure)",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M7-021": {
        "lessonId": "lesson-7-1",
        "lessonTitle": "Vehicle Emergencies (Equipment Failure)",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M7-003": {
        "lessonId": "lesson-7-1",
        "lessonTitle": "Vehicle Emergencies (Equipment Failure)",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M7-002": {
        "lessonId": "lesson-7-1",
        "lessonTitle": "Vehicle Emergencies (Equipment Failure)",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M7-004": {
        "lessonId": "lesson-7-1",
        "lessonTitle": "Vehicle Emergencies (Equipment Failure)",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M7-006": {
        "lessonId": "lesson-7-2",
        "lessonTitle": "Driver Emergencies & Off-Road Recovery",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M7-007": {
        "lessonId": "lesson-7-2",
        "lessonTitle": "Driver Emergencies & Off-Road Recovery",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M7-009": {
        "lessonId": "lesson-7-2",
        "lessonTitle": "Driver Emergencies & Off-Road Recovery",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M7-008": {
        "lessonId": "lesson-7-2",
        "lessonTitle": "Driver Emergencies & Off-Road Recovery",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M7-010": {
        "lessonId": "lesson-7-2",
        "lessonTitle": "Driver Emergencies & Off-Road Recovery",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M7-024": {
        "lessonId": "lesson-7-2",
        "lessonTitle": "Driver Emergencies & Off-Road Recovery",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M7-025": {
        "lessonId": "lesson-7-2",
        "lessonTitle": "Driver Emergencies & Off-Road Recovery",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M7-012": {
        "lessonId": "lesson-7-3",
        "lessonTitle": "Collision Reporting",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M7-011": {
        "lessonId": "lesson-7-3",
        "lessonTitle": "Collision Reporting",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M7-023": {
        "lessonId": "lesson-7-3",
        "lessonTitle": "Collision Reporting",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M7-013": {
        "lessonId": "lesson-7-3",
        "lessonTitle": "Collision Reporting",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M7-014": {
        "lessonId": "lesson-7-3",
        "lessonTitle": "Collision Reporting",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M7-015": {
        "lessonId": "lesson-7-3",
        "lessonTitle": "Collision Reporting",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M7-016": {
        "lessonId": "lesson-7-4",
        "lessonTitle": "Post-Collision Responsibilities",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M7-017": {
        "lessonId": "lesson-7-4",
        "lessonTitle": "Post-Collision Responsibilities",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M7-018": {
        "lessonId": "lesson-7-4",
        "lessonTitle": "Post-Collision Responsibilities",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M7-019": {
        "lessonId": "lesson-7-4",
        "lessonTitle": "Post-Collision Responsibilities",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M7-020": {
        "lessonId": "lesson-7-4",
        "lessonTitle": "Post-Collision Responsibilities",
        "moduleId": "module-7",
        "moduleTitle": "Module 7: Handling Vehicle/Driver Emergencies"
    },
    "M8-024": {
        "lessonId": "lesson-8-1",
        "lessonTitle": "Low Light & Night Conditions",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M8-001": {
        "lessonId": "lesson-8-1",
        "lessonTitle": "Low Light & Night Conditions",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M8-002": {
        "lessonId": "lesson-8-1",
        "lessonTitle": "Low Light & Night Conditions",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M8-003": {
        "lessonId": "lesson-8-1",
        "lessonTitle": "Low Light & Night Conditions",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M8-004": {
        "lessonId": "lesson-8-2",
        "lessonTitle": "Glare: Interior and Exterior",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M8-005": {
        "lessonId": "lesson-8-2",
        "lessonTitle": "Glare: Interior and Exterior",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M8-006": {
        "lessonId": "lesson-8-2",
        "lessonTitle": "Glare: Interior and Exterior",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M8-007": {
        "lessonId": "lesson-8-3",
        "lessonTitle": "Adverse Weather: Rain & Hydroplaning",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M8-023": {
        "lessonId": "lesson-8-3",
        "lessonTitle": "Adverse Weather: Rain & Hydroplaning",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M8-022": {
        "lessonId": "lesson-8-3",
        "lessonTitle": "Adverse Weather: Rain & Hydroplaning",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M8-008": {
        "lessonId": "lesson-8-3",
        "lessonTitle": "Adverse Weather: Rain & Hydroplaning",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M8-009": {
        "lessonId": "lesson-8-3",
        "lessonTitle": "Adverse Weather: Rain & Hydroplaning",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M8-012": {
        "lessonId": "lesson-8-4",
        "lessonTitle": "Reduced Visibility: Fog & Heavy Snow",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M8-011": {
        "lessonId": "lesson-8-4",
        "lessonTitle": "Reduced Visibility: Fog & Heavy Snow",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M8-010": {
        "lessonId": "lesson-8-4",
        "lessonTitle": "Reduced Visibility: Fog & Heavy Snow",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M8-021": {
        "lessonId": "lesson-8-4",
        "lessonTitle": "Reduced Visibility: Fog & Heavy Snow",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M8-013": {
        "lessonId": "lesson-8-4",
        "lessonTitle": "Reduced Visibility: Fog & Heavy Snow",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M8-014": {
        "lessonId": "lesson-8-5",
        "lessonTitle": "Snow, Ice & Extreme Temperatures",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M8-015": {
        "lessonId": "lesson-8-5",
        "lessonTitle": "Snow, Ice & Extreme Temperatures",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M8-016": {
        "lessonId": "lesson-8-5",
        "lessonTitle": "Snow, Ice & Extreme Temperatures",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M8-017": {
        "lessonId": "lesson-8-5",
        "lessonTitle": "Snow, Ice & Extreme Temperatures",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M8-019": {
        "lessonId": "lesson-8-6",
        "lessonTitle": "Vehicle & Driver Preparation",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M8-018": {
        "lessonId": "lesson-8-6",
        "lessonTitle": "Vehicle & Driver Preparation",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M8-020": {
        "lessonId": "lesson-8-6",
        "lessonTitle": "Vehicle & Driver Preparation",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M8-025": {
        "lessonId": "lesson-8-6",
        "lessonTitle": "Vehicle & Driver Preparation",
        "moduleId": "module-8",
        "moduleTitle": "Module 8: Operating in Adverse Conditions"
    },
    "M9-001": {
        "lessonId": "lesson-9-1",
        "lessonTitle": "Your Senses & Driving",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M9-002": {
        "lessonId": "lesson-9-1",
        "lessonTitle": "Your Senses & Driving",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M9-003": {
        "lessonId": "lesson-9-1",
        "lessonTitle": "Your Senses & Driving",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M9-004": {
        "lessonId": "lesson-9-2",
        "lessonTitle": "Emotions & Driving",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M9-005": {
        "lessonId": "lesson-9-2",
        "lessonTitle": "Emotions & Driving",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M9-006": {
        "lessonId": "lesson-9-2",
        "lessonTitle": "Emotions & Driving",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M9-025": {
        "lessonId": "lesson-9-2",
        "lessonTitle": "Emotions & Driving",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M9-024": {
        "lessonId": "lesson-9-3",
        "lessonTitle": "Fatigue & Highway Hypnosis",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M9-007": {
        "lessonId": "lesson-9-3",
        "lessonTitle": "Fatigue & Highway Hypnosis",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M9-009": {
        "lessonId": "lesson-9-3",
        "lessonTitle": "Fatigue & Highway Hypnosis",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M9-008": {
        "lessonId": "lesson-9-3",
        "lessonTitle": "Fatigue & Highway Hypnosis",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M9-010": {
        "lessonId": "lesson-9-4",
        "lessonTitle": "Short-Term Illness & Medications",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M9-012": {
        "lessonId": "lesson-9-4",
        "lessonTitle": "Short-Term Illness & Medications",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M9-011": {
        "lessonId": "lesson-9-4",
        "lessonTitle": "Short-Term Illness & Medications",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M9-014": {
        "lessonId": "lesson-9-5",
        "lessonTitle": "Permanent Disabilities & Adaptive Tech",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M9-013": {
        "lessonId": "lesson-9-5",
        "lessonTitle": "Permanent Disabilities & Adaptive Tech",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M9-015": {
        "lessonId": "lesson-9-6",
        "lessonTitle": "Carbon Monoxide: The Silent Killer",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M9-016": {
        "lessonId": "lesson-9-6",
        "lessonTitle": "Carbon Monoxide: The Silent Killer",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M9-021": {
        "lessonId": "lesson-9-7",
        "lessonTitle": "Alcohol, Drugs & Ohio OVI Laws",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M9-017": {
        "lessonId": "lesson-9-7",
        "lessonTitle": "Alcohol, Drugs & Ohio OVI Laws",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M9-018": {
        "lessonId": "lesson-9-7",
        "lessonTitle": "Alcohol, Drugs & Ohio OVI Laws",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M9-022": {
        "lessonId": "lesson-9-7",
        "lessonTitle": "Alcohol, Drugs & Ohio OVI Laws",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M9-023": {
        "lessonId": "lesson-9-7",
        "lessonTitle": "Alcohol, Drugs & Ohio OVI Laws",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M9-019": {
        "lessonId": "lesson-9-8",
        "lessonTitle": "Distracted Driving & Electronic Devices",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M9-020": {
        "lessonId": "lesson-9-8",
        "lessonTitle": "Distracted Driving & Electronic Devices",
        "moduleId": "module-9",
        "moduleTitle": "Module 9: Driver Fitness"
    },
    "M10-001": {
        "lessonId": "lesson-10-1",
        "lessonTitle": "Buying a Vehicle & Titling",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    },
    "M10-002": {
        "lessonId": "lesson-10-1",
        "lessonTitle": "Buying a Vehicle & Titling",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    },
    "M10-003": {
        "lessonId": "lesson-10-1",
        "lessonTitle": "Buying a Vehicle & Titling",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    },
    "M10-024": {
        "lessonId": "lesson-10-1",
        "lessonTitle": "Buying a Vehicle & Titling",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    },
    "M10-004": {
        "lessonId": "lesson-10-1",
        "lessonTitle": "Buying a Vehicle & Titling",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    },
    "M10-021": {
        "lessonId": "lesson-10-2",
        "lessonTitle": "Insuring a Vehicle: The 25/50/25 Rule",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    },
    "M10-005": {
        "lessonId": "lesson-10-2",
        "lessonTitle": "Insuring a Vehicle: The 25/50/25 Rule",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    },
    "M10-022": {
        "lessonId": "lesson-10-2",
        "lessonTitle": "Insuring a Vehicle: The 25/50/25 Rule",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    },
    "M10-006": {
        "lessonId": "lesson-10-2",
        "lessonTitle": "Insuring a Vehicle: The 25/50/25 Rule",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    },
    "M10-007": {
        "lessonId": "lesson-10-2",
        "lessonTitle": "Insuring a Vehicle: The 25/50/25 Rule",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    },
    "M10-025": {
        "lessonId": "lesson-10-2",
        "lessonTitle": "Insuring a Vehicle: The 25/50/25 Rule",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    },
    "M10-008": {
        "lessonId": "lesson-10-2",
        "lessonTitle": "Insuring a Vehicle: The 25/50/25 Rule",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    },
    "M10-023": {
        "lessonId": "lesson-10-3",
        "lessonTitle": "Maintaining a Vehicle",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    },
    "M10-009": {
        "lessonId": "lesson-10-3",
        "lessonTitle": "Maintaining a Vehicle",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    },
    "M10-010": {
        "lessonId": "lesson-10-3",
        "lessonTitle": "Maintaining a Vehicle",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    },
    "M10-011": {
        "lessonId": "lesson-10-3",
        "lessonTitle": "Maintaining a Vehicle",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    },
    "M10-012": {
        "lessonId": "lesson-10-3",
        "lessonTitle": "Maintaining a Vehicle",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    },
    "M10-013": {
        "lessonId": "lesson-10-4",
        "lessonTitle": "Trip Planning & Efficiency",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    },
    "M10-014": {
        "lessonId": "lesson-10-4",
        "lessonTitle": "Trip Planning & Efficiency",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    },
    "M10-015": {
        "lessonId": "lesson-10-4",
        "lessonTitle": "Trip Planning & Efficiency",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    },
    "M10-016": {
        "lessonId": "lesson-10-4",
        "lessonTitle": "Trip Planning & Efficiency",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    },
    "M10-017": {
        "lessonId": "lesson-10-5",
        "lessonTitle": "Updated Vehicle Technology (ADAS)",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    },
    "M10-018": {
        "lessonId": "lesson-10-5",
        "lessonTitle": "Updated Vehicle Technology (ADAS)",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    },
    "M10-019": {
        "lessonId": "lesson-10-5",
        "lessonTitle": "Updated Vehicle Technology (ADAS)",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    },
    "M10-020": {
        "lessonId": "lesson-10-5",
        "lessonTitle": "Updated Vehicle Technology (ADAS)",
        "moduleId": "module-10",
        "moduleTitle": "Module 10: Responsibilities of Owning & Maintaining a Vehicle"
    }
};
